exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#alerts-in-progress-page-container{width:100%;padding:20px;background-color:#fff}#alerts-in-progress-page-container #alerts-in-progress-title{display:none;width:100%;text-align:left;font-size:26px;padding-left:10px}#alerts-in-progress-page-container .alerts-in-progress-list{padding:10px;width:100%}#alerts-in-progress-page-container .alerts-in-progress-list .ant-table-row{text-align:center}#alerts-in-progress-page-container .alerts-in-progress-list .alerts-in-progress-list-element{width:100%;font-size:26px;border-bottom:1px solid #000}.custom-filter-dropdown{padding:8px;border-radius:6px;background:#fff;box-shadow:0 1px 6px rgba(0,0,0,.2)}.custom-filter-dropdown input{width:130px;margin-right:8px}.highlight{color:#f50}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/alerts/inProgress.scss
// module id = 2198
// module chunks = 43